const setLang = (lang) => {
    if(lang === 'en'){
        document.body.style.direction = 'ltr';
        document.body.classList.remove('rtl');
        document.body.classList.add('ltr');
        document.cookie = 'lang=en';
    }else {
        document.body.style.direction = 'rtl';
        document.body.classList.remove('ltr');
        document.body.classList.add('rtl');
        document.cookie = 'lang=ar';
    }
}

export default setLang;